@if (visible) {
  <div class="notification-dropdown" [class.visible]="visible">
    <!-- Dropdown Header -->
    <div class="dropdown-header">
      <div class="header-title">
        <h6 class="mb-0">Notifications</h6>
        @if (hasUnreadNotifications) {
          <span class="notification-count">
            {{ notificationSummary.unreadCount }} unread
          </span>
        }
      </div>
      <div class="header-actions">
        @if (hasUnreadNotifications) {
          <button
            class="btn btn-sm btn-link"
            (click)="onMarkAllRead()"
            [disabled]="loading"
            title="Mark all as read">
            <i class="mdi mdi-check-all"></i>
          </button>
        }
        <button
          class="btn btn-sm btn-link close-btn"
          (click)="closeDropdown()"
          title="Close">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    </div>
    <!-- Loading Indicator -->
    @if (loading) {
      <div class="loading-indicator">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span class="ms-2">Updating...</span>
      </div>
    }
    <!-- Notifications List -->
    @if (!loading) {
      <div class="notifications-list">
        <!-- No Notifications -->
        @if (!hasNotifications) {
          <div class="no-notifications">
            <div class="no-notifications-content">
              <i class="mdi mdi-bell-sleep"></i>
              <p class="mb-0">No notifications yet</p>
              <small class="text-muted">You'll see new notifications here</small>
            </div>
          </div>
        }
        <!-- Notification Items -->
        @for (notification of notificationSummary.notifications; track notification) {
          <div
            class="notification-item"
            [class.unread]="!notification.isRead"
            (click)="onNotificationClick(notification)">
            <div class="notification-content">
              <!-- Notification Header -->
              <div class="notification-header">
                <div class="notification-user">
                  <i class="mdi mdi-account-circle user-avatar"></i>
                  <span class="user-name">{{ notification.comment.createdBy }}</span>
                </div>
                <div class="notification-time">
                  {{ getTimeAgo(notification) }}
                </div>
              </div>
              <!-- Notification Message -->
              <div class="notification-message">
                <span class="notification-action">commented on </span>
                <span class="notification-target">{{ notification.comment.targetType }} #{{ notification.comment.targetId }}</span>
              </div>
              <!-- Comment Preview -->
              <div class="comment-preview">
                "{{ getTruncatedComment(notification) }}"
              </div>
            </div>
          </div>
        }
      </div>
    }
    <!-- Footer -->
    @if (hasNotifications && !loading) {
      <div class="dropdown-footer">
        @if (notificationSummary.hasMore) {
          <button
            class="btn btn-sm btn-link view-all-btn"
            (click)="onViewAll()"
            >
            View all notifications
          </button>
        }
        @if (!notificationSummary.hasMore) {
          <small class="text-muted">
            All recent notifications shown
          </small>
        }
      </div>
    }
  </div>
}

<!-- Backdrop -->
@if (visible) {
  <div class="notification-backdrop" (click)="closeDropdown()"></div>
}
